import React from "react";
import { Button } from "../styles/commonStyles";
import styled from "styled-components";

const PendingNote = ({
  statusText = "Pending",
  message,
  buttonText,
  onBtnClick,
  btnStyle,
}) => {
  return (
    <PendingNoteContainer>
      <MessageContainer>
        <StatusChip>{statusText}</StatusChip>
        <NoteMessage>{message}</NoteMessage>
      </MessageContainer>

      <Button style={btnStyle} onClick={onBtnClick}>
        {buttonText}
      </Button>
    </PendingNoteContainer>
  );
};

export default PendingNote;

export const PendingNoteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d79900;
  background: rgba(253, 242, 220, 0.5);
  border-radius: 12px;
`;

export const StatusChip = styled.div`
  background: #f6bc2f;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
  line-height: 18px;
  font-size: 14px !important;
  width: max-content;
`;

export const MessageContainer = styled.div``;

export const NoteMessage = styled.div`
  font-size: 14px !important;
  font-weight: 500;
  line-height: 18px;
  max-width: 100%;
  margin-top: 6px;
`;
